class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);

      // start: on removing item from cart it will check and remove atc btns attributes/classes responsible for chekcout functionality
      const productFormWrapper = Array.from(document.querySelectorAll('.buy_buttons__wrapper .product-form')).find(form => form.style !== 'display:none;');
      const productFormMobile = document.querySelector('.mobile-sticky-bar-wrapper .mobile-checkout-url');
      if(productFormWrapper && typeof productFormWrapper !== 'undefined') {
        const productForm = productFormWrapper.querySelector('[data-btn-action-checkout]');
        productForm?.removeAttribute('data-btn-action-checkout');
        productFormWrapper.querySelector('.checkout-url')?.classList.remove('checkout-url');
        if(productFormMobile && typeof productFormMobile !== 'undefined') productFormMobile.classList.remove('mobile-checkout-url');
      }
      // end: on removing item from cart it will check and remove atc btns attributes/classes responsible for chekcout functionality
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartUpsellButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      let treesValue, treesValuePerItem = 0;
      const productId = this.getAttribute('data-variant-id');
      const quantity = parseInt(this.getAttribute('data-quantity'));
      const currentQuantity = parseInt(this.getAttribute('data-product-added-quantity')) || 0;

      // Find the sibling loading spinner next to the button
      const spinner = this.parentElement.querySelector('.loading__spinner');
    
      // Show the spinner and hide the button
      if (spinner) {
        spinner.classList.remove('hidden'); // Show the spinner
        this.classList.add('hidden'); // Hide the button
      }

      // First, try to find the cart context (cart-items or cart-drawer-items)
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      
      // If the context is not found, log the error and prevent further execution
      if (!cartItems) {
        console.error('Cart context not found');
        return;
      }

      // Call the addUpsellProduct method on the cartItems element
      if (typeof cartItems.addUpsellProduct === 'function') {
        // add "_treePlant" and "_treePlantPerItem" property with propertiers object
        if(this.hasAttribute('data-product-tree-plant-per-item')) {
          treesValue = Number(this.getAttribute('data-product-tree-plant'));
          treesValuePerItem = Number(this.getAttribute('data-product-tree-plant-per-item'));
        }

        cartItems.addUpsellProduct(productId, quantity, treesValuePerItem, currentQuantity)
          .then(() => {
            // After the product is added and cart is updated, hide the spinner and show the button again
            if (spinner) {
              spinner.classList.add('hidden'); // Hide the spinner
              this.classList.remove('hidden'); // Show the button
            }
          })
          .catch((error) => {
            console.error('Error in addUpsellProduct:', error);
            // If error, ensure the button is restored
            if (spinner) {
              spinner.classList.add('hidden');
              this.classList.remove('hidden');
            }
          });
      } else {
        console.error('addUpsellProduct method not found on cart context');
      }
    });
  }
}

customElements.define('cart-upsell-button', CartUpsellButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.sectionId = document.querySelector('#CartDrawer')?.dataset.sectionId;

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId,
      'cart-input',
      event.target.dataset.lineKey,
      event.target.dataset.addonLineItem,
      event.target.dataset.itemData
    );
  }

  onCartUpdate() {
    // TODO: Add logic to remove add-ons from the cart when parent product is removed
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=${this.sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const quantityInputs = html.querySelectorAll('.quantity__input');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          this.updateCartCount(quantityInputs);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  updateCartCount(quantityInputs) {
    let totalCount = 0;

    // Iterate over each quantity input and sum up the values
    quantityInputs.forEach((input) => {
      totalCount += parseInt(input.value);
    });

    // Update the header cart count
    const cartCountElement = document.querySelector('.header__cart-button-count');
    cartCountElement.innerHTML = totalCount;

    // Update the drawer cart count
    const drawerCountElement = document.querySelector('.drawer__cart-button-count');
    drawerCountElement.innerHTML = "(" + totalCount + ")";

    // Show or hide the cart count element based on the total count
    if (totalCount === 0) {
      cartCountElement.classList.add('header__cart-button-count--hidden');
      // when cart is empty, initialize swiper for empty cart 
      initializeSwiper('.swiper-container.cart-drawer-slider');
    } else {
      cartCountElement.classList.remove('header__cart-button-count--hidden');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '#main-cart-items .js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.header-cart-icon',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '#cart-live-region-text .shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#main-cart-footer .js-contents',
      },
      {
        id: 'left-cart-popup',
        section: document.getElementById('left-cart-popup').dataset.id,
        selector: '#left-cart-popup .left-cart-popup__items-wrapper',
      }
    ].filter(section => section.section);
  }

  updateQuantity(line, quantity, name, variantId, source, key, lineType, lineData) {
    this.enableLoading(line);

    // to avoid cart quantity update issue for same variant line items (addons only) added separately: variable 'keyVariant' is used to update right line item quantity
    const keyVariant = lineType === 'true' && key ? key : variantId;
    const updates = {
      [source === 'cart-input' ? keyVariant : line]: quantity
    }

    if (quantity === 0) {
      const item = document.getElementById(`CartDrawer-Item-${line.replace(':', '-')}`);
      const addOns = item.querySelectorAll('[data-child-line-item]:not([data-child-line-item=""]');

      addOns.forEach((addOn) => {
        const childLineItem = addOn.dataset.childLineItem;
        updates[childLineItem] = 0;
      });
    }

    // check if line_item properties exists and contains treePlantPerItem info
    let lineProperties, lineTreePlantValue;
    if(lineData) {
      const lineDataParsed = JSON.parse(lineData);
      lineProperties = lineDataParsed.properties;
      lineTreePlantValue = parseInt(lineProperties._treePlantPerItem) * parseInt(quantity);
    }

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        try{
        this.getSectionsToRender().forEach((section) => {
          const elementsToReplace = section.selector
            ? document.querySelectorAll(section.selector)
            : document.querySelectorAll('#' + section.id);

          // If no elements were found, simply skip this section.
          if (!elementsToReplace.length) {
            return;
          }

          elementsToReplace.forEach((elementToReplace) => {
            const sectionContent = parsedState.sections[section.section];
            // Check if the related parsedState data exists
            if (!sectionContent) {
              console.warn(`Missing content for section: ${section.section}`);
              return; // or continue to the next iteration
            }
            const content = this.getSectionInnerHTML(sectionContent, section.selector);
            elementToReplace.innerHTML = content;
          })
        });
      } catch (error) {
        console.error('Error during section update:', error);
      }
        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        // update line_item '_treePlant' property
        if(lineProperties?.hasOwnProperty('_treePlantPerItem')) {
          this.updateTreePlantProperty(line, quantity, lineProperties, lineTreePlantValue);
        }

        this.onCartUpdate();

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        // call estimated delivery function to fix broken msg if available
        if(typeof estimatedDeliveryDate !== 'undefined') estimatedDeliveryDate();
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  // send 'cart/change.js' request if line_item have '_treePlantPerItem' property with current line, quantity, properties + updated '_treePlant' property value
  updateTreePlantProperty(line, quantity, lineProperties, lineTreePlantValue) {
    const lineBody = JSON.stringify({
      line,
      quantity,
      properties: {...lineProperties, _treePlant: lineTreePlantValue}
    })
    
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: lineBody })
    .then(res => res.json())
    .catch(error => console.error(error));
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line.replace(':', '-')} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line.replace(':', '-')} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line.replace(':', '-')} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line.replace(':', '-')} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  addUpsellProduct(productId, quantity, treesValuePerItem, currentQuantity) {
    quantity = quantity + currentQuantity;
    const updates = {
      [productId]: quantity,
    };
  
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({updates}),
    })
    .then((response) => response.json())
    .then((addResponse) => {
      const line = Array.from(addResponse.items).find(item => item.id === Number(productId));
      const currTreeValue = line.properties._treePlant || treesValuePerItem;
      const updatedTreeValue = line.quantity * treesValuePerItem;
      if(currTreeValue) {
        const changedData = {
          'id': productId,
          'quantity': line.quantity,
          properties: {
            ...addResponse.properties,
            '_treePlant': updatedTreeValue,
            '_treePlantPerItem': treesValuePerItem
          },
          sections: `${this.sectionId}`,
        }

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(changedData),
        })
        .then(res => res.json())
        .then(data => {
          // update cart-drawer
          if(data.sections[this.sectionId] && document.querySelector('cart-drawer')) {
            const updatedHtml = new DOMParser().parseFromString(data.sections[this.sectionId], 'text/html');
            document.querySelector('cart-drawer').innerHTML = updatedHtml.querySelector('cart-drawer').innerHTML;
          }
        })
        .catch(error => console.error('line_item property update error:', error));
      }
      // Trigger onCartUpdate after successfully adding the product
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems && typeof cartItems.onCartUpdate === 'function') {
        cartItems.onCartUpdate();
      } else {
        console.error('Cart context not found or onCartUpdate method is missing.');
      }
    })
    .catch((error) => {
      console.error('Error adding upsell product to cart:', error);
      throw error; // Re-throw to propagate the error back to the button's promise chain
    });
  }


}

customElements.define('cart-items', CartItems);


if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
